import { render, staticRenderFns } from "./branchPage.vue?vue&type=template&id=35c9acc1"
import script from "./branchPage.vue?vue&type=script&lang=js"
export * from "./branchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports